module.exports = __webpack_public_path__ + "static/media/Guinness_World_Records_logo.36c561fe.png";